import { usePermissions } from "../../../server/auth/use-permissions";
import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { useAccountLimitsContext } from "../../context/account-limit-context";
import { SupabaseAccountService } from "../../generic/server/supabase-account-service";

import type { ChannelName } from "../../channels/types";

export type AnalyticsTab =
  | Exclude<NonNullable<ChannelName>, "whatsapp">
  | "overview"
  | "surveys"
  | "mfai";
type AnalyticsPerms = AnalyticsTab[] | "loading" | "none";

export const useAnalyticsPerms = (): AnalyticsPerms => {
  const perms = usePermissions();
  const { listen_entitlement } = useAccountLimitsContext();

  const channels = useSupabaseLoader(
    async ({ supabase, account_id }) =>
      await new SupabaseAccountService(supabase).getEnabledChannels(account_id),
    [],
  );

  if (!perms.super_admin && !perms.isLoading) return "none";
  if (channels.loading || perms.isLoading) {
    return "loading";
  }

  return [
    "overview",
    "mfai",
    ...(listen_entitlement !== "Disabled" ? ["surveys"] : []),
    ...(channels.data || []).filter((channel) => channel !== "whatsapp"),
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  ] as AnalyticsTab[];
};
